import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const RefundsPage = lazy(() => import('@/pages/refunds'));

export const Route = createFileRoute('/refunds')({
  component: function RefundsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <RefundsPage />
      </Suspense>
    );
  },
});
